<template>
<div>
  <v-dialog v-model="show"
            persistent
            content-class="dialog-adm"
            :width="width">
    <base-dialog-layout>
      <template v-slot:title>
        {{title}}
        <div ref="topTarget"></div>
      </template>
      <template v-slot:content>
        <div class="dialog-main-adm">
          <slot></slot>
        </div>
      </template>
      <template v-slot:btn>
        <slot name="btn">
          <v-btn color="secondary"
                 outline
                 @click="close">{{btnCloseText}}</v-btn>
          <v-btn v-if="btnEvent"
                 color="secondary"
                 @click="event">{{btnEventText}}</v-btn>
          <v-btn v-if="btnConfirm"
                 :disabled="btnConfirmDisabled"
                 color="secondary"
                 @click="save">{{btnConfirmText}}</v-btn>
        </slot>
      </template>
    </base-dialog-layout>
  </v-dialog>
</div>
</template>
<script>
export default {
  name: 'base-dialog-adm',
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '600'
    },
    show: {
      type: Boolean,
      default: false
    },
    btnCloseText: {
      type: String,
      default: '取消'
    },
    btnConfirmText: {
      type: String,
      default: '確認'
    },
    btnEventText: {
      type: String,
      default: '送審'
    },
    btnEvent: {
      type: Boolean,
      default: false
    },
    btnConfirm: {
      type: Boolean,
      default: true
    },
    btnConfirmDisabled: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    show (v) {
      if (!v) {
        this.scrollTop()
      }
    }
  },

  methods: {
    scrollTop (scrollIntoViewOptions) {
      const options = { ...{ block: 'end' }, ...scrollIntoViewOptions }
      this.$refs['topTarget'].scrollIntoView(options)
    },
    close () {
      this.$emit('close')
    },
    save () {
      this.$emit('save')
    },
    event () {
      this.$emit('event')
    }
  }
}
</script>
